import { MSCIAllWorldLogo } from './MSCIAllWorldLogo';
import { OpportunitiesPlusLogo } from './OpportunitiesPlusLogo';
import { EmergingMarketLogo } from './EmergingMarketLogo';
import { GlobalGrowthLogo } from './GlobalGrowthLogo';
import { NorthAmericanOpportunitiesLogo } from './NorthAmericanOpportunitiesLogo';
import { ManagedFundLogo } from './ManagedFundLogo';
import { AggressiveLogo } from './AggressiveLogo';
import { BalancedLogo } from './BalancedLogo';
import { CautiousLogo } from './CautiousLogo';
import { MultiAssetSustainableBalancedLogo } from './MultiAssetSustainableBalancedLogo';
import { ECommerceFundLogo } from './ECommerceFundLogo';
import { LuxuryFundLogo } from './LuxuryFundLogo';
import { NewTechnologiesLogo } from './NewTechnologiesLogo';
import { SP500TrackerLogo } from './SP500TrackerLogo';
import { NasdaqTrackerLogo } from './NasdaqTrackerLogo';
import { NiftyFiftyTrackerLogo } from './NiftyFiftyTrackerLogo';
import { PhysicalGoldTrackerLogo } from './PhysicalGoldTrackerLogo';
import { G10MacroRatesLogo } from './G10MacroRatesLogo';
import { GlobalBondsLogo } from './GlobalBondsLogo';
import { CashLogo } from './CashLogo';
import { BitcoinTrackerLogo } from './BitcoinTrackerLogo';

// Map fund names to their logo components
export const fundLogos: Record<string, React.ComponentType<{ className?: string }>> = {
  'DCS MSCI All World Tracker Fund': MSCIAllWorldLogo,
  'Opportunities Plus': OpportunitiesPlusLogo,
  'DCS Emerging Market Equities': EmergingMarketLogo,
  'DCS Global Growth': GlobalGrowthLogo,
  'DCS North American Opportunities Fund': NorthAmericanOpportunitiesLogo,
  'DCS Managed Fund': ManagedFundLogo,
  'DGT Managed Fund': ManagedFundLogo, // Same logo as DCS Managed Fund
  'DCS Aggressive': AggressiveLogo,
  'DCS Balanced': BalancedLogo,
  'DCS Cautious': CautiousLogo,
  'DCS Multi Asset Sustainable - Balanced': MultiAssetSustainableBalancedLogo,
  'DGT E-Commerce Fund': ECommerceFundLogo,
  'DGT Luxury Fund': LuxuryFundLogo,
  'DCS New Technologies': NewTechnologiesLogo,
  'DCS S&P 500 Tracker': SP500TrackerLogo,
  'Nasdaq Tracker fund': NasdaqTrackerLogo,
  'DCS Nifty Fifty Tracker Fund': NiftyFiftyTrackerLogo,
  'DCS Physical Gold Tracker Fund': PhysicalGoldTrackerLogo,
  'DCS G10 Macro Rates': G10MacroRatesLogo,
  'DCS Global Bonds': GlobalBondsLogo,
  'DCS Cash': CashLogo,
  'Bitcoin Tracker Fund': BitcoinTrackerLogo,
};

// Helper function to get logo component by fund name
export function getFundLogo(fundName: string) {
  return fundLogos[fundName] || null;
}